import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { TransitionContainerNoExit } from '../../components/Transition/TranstionContainer';

import ConfirmationCard from '../../components/Shared/ConfirmationCard';
import { Title } from '../../components/Shared/TitleSuccess';

import { StatesAbbreviation, ActionTypes } from '../../utils/enums';
import { setExitingCardProps, getExitingCardProps } from '../Widget/actions';

const TitleComponent = () => <Title>Congrats on choosing to register to vote.</Title>;

TitleComponent.propTypes = {};

const VoteRegistrationSuccess = props => (
    <TransitionContainerNoExit>
        <ConfirmationCard
            thankYouText={props.thankYouText}
            titleComponent={<TitleComponent />}
            hideSubtitle={true}
            beforeAdvancing={() => {
                props.setExitingCardProps('voteRegistration', props, props.exitingAction);
            }}
            {...props}
        />
    </TransitionContainerNoExit>
);

VoteRegistrationSuccess.propTypes = {
    exitingAction: PropTypes.object.isRequired,
    setExitingCardProps: PropTypes.func.isRequired,
    thankYouText: PropTypes.string.isRequired
};

export default connect(
    (state, props) => {
        const exitingProps = getExitingCardProps(
            'voteRegistration',
            ['/voteRegistration/success'],
            props.location.pathname,
            state
        );
        if (exitingProps) return exitingProps;

        return {
            exitingAction: state.widget.activeAction,
            thankYouText: `The ${
                StatesAbbreviation[state.voteRegistration.formData.stateId]
            } state website will let you register completely online!`
        };
    },
    { setExitingCardProps },
    null,
    {
        areStatesEqual: (next, prev) => {
            if (next.widget.activeAction.type !== ActionTypes.VoteRegistration)
                return true;

            return next === prev;
        }
    }
)(VoteRegistrationSuccess);
